import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n.use(LanguageDetector).init({

    debug: false,

    resources: {
        /*en: {
            translations: {
                "welcomeZSKHeader": "Welcome to MY.ZSK",
            }
        },
        de: {
            translations: {
                "welcomeZSKHeader": "Willkommen in der MY.ZSK",
            }
        }*/
    },

    supportedLngs: ['de','en','es','fr','it','pl','pt','ru','tr'],
    load: 'languageOnly',
    fallbackLng: "en",

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",

    keySeparator: false, // we use content as keys

    interpolation: {
        escapeValue: false, // not needed for react!!
        formatSeparator: ","
    },

    react: {
        wait: true
    }

});

export default i18n;